import { compose } from 'recompose'
import { connect } from 'react-redux';
import { getHistorico } from '../../../../../DinamicForms/actions'

const mapStateToProps = ({ PerfisAdminReducer }, props) => {


    return { perfis: PerfisAdminReducer.rLista.lista };
};



export default compose(
    connect(mapStateToProps, { getHistorico })
)


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Historico/components/ListaHistorico/ListaHistorico.enhancer.js